import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { decrypt } from '../../../common/enc_dec';
import { users } from '../../../slices/userSlice';
import UserDetailsView from './userDetailsView';
import UserCourses from './userCourseList';

const ViewUserReport = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { id } = location?.state || {};
    const queryParams = new URLSearchParams(location.search);
    const _id = decrypt(queryParams.get("id"));
    const userId = id || _id;

    useEffect(() => {
        if (userId) {
            dispatch(users({
                payload: { id: userId }
            }));
        }
    }, [dispatch, userId]);

    return (
        <div className="content-page">
            <UserDetailsView />

            <div className="card mt-3 shadow-sm">
                <div className="card-body">
                    <h5 className="card-title fw-semibold">📚 Course History</h5>
                    <p className="card-text text-muted">
                        <UserCourses />
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ViewUserReport;